module.exports = __webpack_public_path__ + "static/apple-icon-144x144-d6a947c29b046b81fadeb11f6b6d54cd.png";